import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'app/modules/BusinessRegistration/BusinessRegistration.scss';
import Form from 'react-bootstrap/Form';
import { Col, Button, Row } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import PasswordField from 'app/modules/Shared/PasswordField/PasswordField';
import PasswordRequirements from 'app/modules/Shared/PasswordRequirements/PasswordRequirements';
import {
  isPasswordFormatValid,
  preventNonDigitCharacters,
  formatPhoneNumber,
} from 'utils/common';
import Pending from 'app/modules/Shared/Pending/Pending';
import FormNavigationBar from 'app/modules/Shared/FormNavigationBar/FormNavigationBar';
import WithError from 'app/modules/Shared/WithError/WithError';
import 'app/modules/Shared/WithError/WithError.scss';
import Select from 'react-select';
import http from 'api/http-request';
import { getNestedObject } from 'utils/common';
import Alert from 'app/modules/Shared/Alert/Alert';
import GoogleCaptcha from '../Shared/GoogleCaptcha/GoogleCaptcha';
import moment from 'moment';
const CryptoJS = require('crypto-js');

class BusinessRegistration extends Component {
  constructor(props) {
    super(props);
    this.passwordInputRef = React.createRef();
    this.confirmPasswordInputRef = React.createRef();
    this.verificationInputRef = React.createRef();
    this.telephoneNumberInputRef = React.createRef();
    this.state = {
      password: '',
      confirmPassword: '',
      screen: 0,
      verificationPlaceholder: ['0', '0', '0', '0', '0', '0', '0', '0'],
      currentStep: 0,
      stepNames: [
        'pages.formNavigator.generalInfo',
        'pages.formNavigator.securityQuestion',
        'pages.formNavigator.captcha',
        'pages.formNavigator.review',
      ],
      maxStep: 3,
      showGoogleCaptcha: false,
      googleCaptchaToken: '',
      googleCaptchaResponse: '',
      captchaReset: false,
      givenName: '',
      answerOne: '',
      answerTwo: '',
      answerThree: '',
      customeApp: '',

      sn: '',
      userName: '',
      businessName: '',
      businessRole: '',
      description: '',
      businessRoleDescription: '',
      mail: '',
      confirmEmail: '',
      confirmPasswordError: '',
      businessNameError: '',
      businessRoleError: '',
      businessRoleDescriptionError: '',
      passwordError: '',
      formSubmitted: false,
      errorText: '',
      errorArray: [],
      questionVals: [null, null, null],
      token: '',
      telephoneNumber: '',
      telephoneNumberUSFormatted: '',
      numberFocus: false,
      preferredLanguage: 'en',
      filterOptions: [],
      verificationCode: '',
      verificationOption: '',
      verificationCodeError: '',
      telephoneNumberFormatted: '',
      copyEmailToUsername: false,
      businessRegistrationPayLoad: {},

      organizationList: [
        {
          value: 'Deloitte',
          label: 'Deloitte',
        },
        {
          value: 'Salesforce',
          label: 'Salesforce',
        },
        {
          value: 'ServiceNow',
          label: 'ServiceNow',
        },
        {
          value: 'AWS',
          label: 'AWS',
        },
      ],
    };
  }

  componentDidMount() {
    this.scrollToTop();
  }

  getSecurityQuestion = () => {
    http({
      url: 'getKBA',
      method: 'GET',
    }).then((res) => {
      if (res.data && res.status === 200 && res.data.iamcode === 'IAM000') {
        const questions = res.data.data.questions;
        let final = Object.keys(questions).map((item) => {
          return questions[item].en;
        });
        let filterOptionsFromServer = this.mapQuestionDictToArray(final);
        this.setState({
          filterOptions: filterOptionsFromServer,
        });
      } else {
        this.showError('pages.editNumberPopup.requestedResourceNotFound');
      }
    });
  };

  mapQuestionDictToArray = (questionDict) => {
    let filterOptions = questionDict.map((k, i) => {
      let dict = {};
      dict['value'] = i;
      dict['label'] = questionDict[i];
      dict['translations'] = questionDict[i];
      return dict;
    });
    return filterOptions;
  };

  scrollToTop = () => {
    let scrollElement = document.getElementsByClassName('App-View')[0];
    scrollElement
      ? scrollElement.scrollTo({
          behavior: 'smooth',
          top: 0,
        })
      : '';
  };

  /*
  getToken = () => {
    http(
      {
        url: 'selfservice/registration?_action=submitRequirements',
        data: { input: { input: {} } },
        method: 'POST',
      },
      {
        'X-OpenIDM-NoSession': true,
        'X-OpenIDM-Username': 'anonymous',
        'X-OpenIDM-Password': 'anonymous',
      }
    ).then((res) => {
      if (
        res.status === 200 &&
        res.data &&
        res.data.tag === 'initial' &&
        res.data.type === 'allInOneRegistration'
      ) {
        this.setState({
          token: res.data.token,
        });
      }
    });
  };
  */
  checkUsername = () => {
    const {
      givenName,
      sn,
      userName,
      mail,
      password,
      telephoneNumber,
      preferredLanguage,
      businessName,
      businessRole,
      businessRoleDescription,
      businessRegistrationPayLoad,
    } = this.state;

    let key = CryptoJS.enc.Latin1.parse('1234567812345678');
    let iv = CryptoJS.enc.Latin1.parse('1234567812345678');
    let encrypted = CryptoJS.AES.encrypt(password, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.ZeroPadding,
    });

    this.setState({
      errorText: '',
    });

    let description;
    if (businessRoleDescription === '') {
      description = ' ';
    } else {
      description = businessRoleDescription;
    }

    if (telephoneNumber) {
      businessRegistrationPayLoad.givenName = givenName;
      businessRegistrationPayLoad.sn = sn;
      businessRegistrationPayLoad.userName = userName;
      businessRegistrationPayLoad.mail = mail;
      businessRegistrationPayLoad.password = encrypted.toString();
      businessRegistrationPayLoad.department = businessName;
      businessRegistrationPayLoad.jobTitle = businessRole;
      businessRegistrationPayLoad.description = description;
      businessRegistrationPayLoad.startDate = moment(new Date()).format(
        'MM/DD/YYYY'
      );
      businessRegistrationPayLoad.endDate = '12/30/2022';
      //businessRegistrationPayLoad._processDefinitionId = `${process.env.REACT_APP_PROCESS_DEFINITION_ID}`;
      businessRegistrationPayLoad.telephoneNumber =
        '+1' + telephoneNumber.replace(/[^A-Z0-9]/gi, '');
      businessRegistrationPayLoad.provisionToCSV = 'false';
      businessRegistrationPayLoad.preferredLanguage = preferredLanguage;
      this.setState({
        telephoneNumberFormatted: businessRegistrationPayLoad.telephoneNumber,
      });
    } else {
      businessRegistrationPayLoad.givenName = givenName;
      businessRegistrationPayLoad.sn = sn;
      businessRegistrationPayLoad.userName = userName;
      businessRegistrationPayLoad.mail = mail;
      businessRegistrationPayLoad.password = encrypted.toString();
      businessRegistrationPayLoad.department = businessName;
      businessRegistrationPayLoad.jobTitle = businessRole;
      businessRegistrationPayLoad.description = description;
      businessRegistrationPayLoad.startDate = moment(new Date()).format(
        'MM/DD/YYYY'
      );
      businessRegistrationPayLoad.endDate = '12/30/2022';
      // businessRegistrationPayLoad._processDefinitionId = `${process.env.REACT_APP_PROCESS_DEFINITION_ID}`;
      businessRegistrationPayLoad.provisionToCSV = 'false';
      businessRegistrationPayLoad.telephoneNumber = ' ';
      businessRegistrationPayLoad.preferredLanguage = preferredLanguage;
      // businessRegistrationPayLoad.ApproverGroup = `${businessName}Admin`;
    }
    if (businessRegistrationPayLoad && telephoneNumber !== '') {
      this.increaseCurrentStepHandler();
      this.setState({
        screen: 1,
        businessRegistrationPayLoad: businessRegistrationPayLoad,
      });
    }
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.setState({
      formSubmitted: true,
    });
    const {
      givenName,
      sn,
      userName,
      businessName,
      businessRole,
      businessRoleDescription,
      mail,
      confirmEmail,
      password,
      confirmPassword,
      telephoneNumber,
    } = this.state;
    const hasGivenName = this.isFormFieldValid(givenName, 'givenNameError');
    const hasBusinessName = this.validateBusinessName();
    const hasBusinessRole = this.isFormFieldValid(
      businessRole,
      'businessRoleError'
    );
    /*
    const hasBusinessRoleDescription = this.isFormFieldValid(
      businessRoleDescription,
      'businessRoleDescriptionError'
    );*/
    //const hasCustomeApp = this.isFormFieldValid(customeApp, 'customeAppError');
    const hasSn = this.isFormFieldValid(sn, 'snError');
    //const hasCustomApp2 = this.isFormFieldValid(customApp2, 'customApp2Error');
    const hasUserName = this.isFormFieldValid(userName, 'userNameError');
    const hasMail = this.isFormFieldValid(mail, 'emailError');
    const hasConfirmMail = this.isFormFieldValid(
      confirmEmail,
      'confirmEmailError'
    );
    const hasPassword = this.isFormFieldValid(password, 'passwordError');
    const hasConfirmPassword = this.isFormFieldValid(
      confirmPassword,
      'confirmPasswordError'
    );
    const hasTelephoneNumber = this.isFormFieldValid(
      telephoneNumber,
      'telephoneNumberError'
    );
    if (
      hasGivenName ||
      hasBusinessName ||
      hasBusinessRole ||
      hasSn ||
      hasUserName ||
      hasMail ||
      hasConfirmMail ||
      hasPassword ||
      hasConfirmPassword ||
      hasTelephoneNumber
    ) {
      this.showError('errors.required');
    }
    // else {
    //   if (telephoneNumber !== '') {
    //     const currentValue = this.state.telephoneNumber;
    //     this.setState((prevState) => ({
    //       ...prevState,
    //       telephoneNumber: formatPhoneNumber(
    //         currentValue,
    //         prevState.telephoneNumber
    //       ).replace(/[^A-Z0-9]/gi, ''),
    //     }));
    //     this.checkUsername();
    //   } else if (telephoneNumber === '') {
    //     this.checkUsername();
    //   } else {
    //     this.setState({
    //       telephoneNumberError: 'pages.registration.mobileNumberInvalid',
    //     });
    //     this.showError('pages.registration.mobileNumberInvalid');
    //   }
    // }
    else {
      this.checkUsername();
      this.getSecurityQuestion();
    }
  };
  onNext = () => {
    this.increaseCurrentStepHandler();
    this.setState({
      screen: 3,
    });
  };
  increaseCurrentStepHandler = () => {
    this.scrollToTop();
    if (this.state.currentStep < this.state.maxStep) {
      this.setState((prev) => ({
        currentStep: prev.currentStep + 1,
      }));
    }
  };

  onVerify = () => {
    // update businessRegistrationPayload

    const {
      givenName,

      sn,
      userName,
      mail,
      password,
      answerOne,
      answerTwo,
      answerThree,
      questionVals,
      token,
      telephoneNumberFormatted,
      businessRegistrationPayLoad,
      preferredLanguage,
    } = this.state;
    this.setState({
      errorText: '',
    });
    const hasAnswerOne = this.isFormFieldValid(answerOne, 'answerOneError');
    const hasAnswerTwo = this.isFormFieldValid(answerTwo, 'answerTwoError');
    const hasAnswerThree = this.isFormFieldValid(
      answerThree,
      'answerThreeError'
    );
    if (
      hasAnswerOne ||
      hasAnswerTwo ||
      hasAnswerThree ||
      !questionVals[0] ||
      !questionVals[1] ||
      !questionVals[2]
    ) {
      this.showError('errors.required');
    } else if (
      answerOne === answerTwo ||
      answerOne === answerThree ||
      answerTwo === answerThree
    ) {
      this.showError('errors.duplicateEntries');
    } else {
      let updatedPayload = {
        ...businessRegistrationPayLoad,
        SecurityQ1: questionVals[0].label,

        SecurityA1: answerOne,

        SecurityQ2: questionVals[1].label,

        SecurityA2: answerTwo,

        SecurityQ3: questionVals[2].label,

        SecurityA3: answerThree,
      };

      this.increaseCurrentStepHandler();
      this.setState({
        businessRegistrationPayLoad: updatedPayload,
        screen: 4,
      });
    }
  };

  captchaSubmit = () => {
    const { businessRegistrationPayLoad } = this.state;
    this.setState({
      errorText: '',
    });

    http({
      url: 'businessRegistration',
      data: businessRegistrationPayLoad,
      method: 'POST',
    }).then((res) => {
      if (res.data.iamcode === 'IAM000') {
        this.increaseCurrentStepHandler();
        this.setState({
          screen: 3,
        });
      }
    });
  };

  onErrorHandler = (status, message) => {
    let alertText = '';
    if (message === 'TWILIO_ERROR') {
      alertText = 'errors.twilioError';
    } else if (
      message === 'MAX_RETRY_EXCEEDED' ||
      message === 'MAX_RESEND_EXCEEDED'
    ) {
      alertText = 'errors.maxVerifyAttempt';
    }
    if (status === 'error') {
      this.setState(
        {
          alertStatus: status,
          alertText,
        },
        () => {
          setTimeout(() => {
            this.setState({
              alertText: '',
            });
          }, 3000);
        }
      );
      this.scrollToTop();
    }
  };

  onVerificationCodeSubmit = (e) => {
    e.preventDefault();
    const { token, verificationCode } = this.state;
    if (verificationCode === '') {
      this.setState({
        verificationCodeError: 'pages.forgotUserId.verificationCodeRequired',
      });
    } else {
      this.setState({
        verificationCodeError: '',
      });
      http(
        {
          url: 'selfservice/registration?_action=submitRequirements',
          data: {
            input: {
              verificationCode: verificationCode,
            },
            token: token,
          },
          method: 'POST',
        },
        {
          'X-OpenIDM-NoSession': true,
          'X-OpenIDM-Username': 'anonymous',
          'X-OpenIDM-Password': 'anonymous',
        }
      ).then((res) => {
        if (
          res.status === 200 &&
          res.data &&
          res.data.type === 'EmailValidation' &&
          res.data.tag === 'VALIDATE_CODE'
        ) {
          this.setState({
            verificationCodeError: 'pages.forgotUserId.invalidVerificationCode',
          });
          const token = getNestedObject(res, ['data', 'token']);
          if (token) {
            this.setState({
              token: token,
            });
          }
        } else if (
          res.status === 200 &&
          res.data &&
          res.data.type === 'localAutoLogin' &&
          res.data.tag === 'end'
        ) {
          this.setState({
            screen: 3,
          });
        } else if (
          res.status === 400 &&
          res.data &&
          res.data.code === 400 &&
          res.data.message === 'MAX_RETRY_EXCEEDED'
        ) {
          this.setState({
            screen: 0,
            currentStep: 0,
            password: '',
            confirmPassword: '',
            googleCaptchaResponse: '',
            captchaReset: false,
            givenName: '',

            answerOne: '',
            answerTwo: '',
            answerThree: '',
            sn: '',

            userName: '',
            businessName: '',
            businessRole: '',
            description: '',
            mail: '',
            confirmEmail: '',
            confirmPasswordError: '',
            businessNameError: '',
            businessRoleError: '',
            businessRoleDescriptionError: '',
            passwordError: '',
            formSubmitted: false,
            errorText: '',
            errorArray: [],
            token: '',
            telephoneNumber: '',
            telephoneNumberUSFormatted: '',
            verificationCode: '',
            verificationOption: '',
            verificationCodeError: '',
            questionVals: [null, null, null],
          });
          this.onErrorHandler('error', res.data.message);
          // this.getToken();
        }
      });
    }
  };

  disableCopyPaste = (e) => {
    e.preventDefault();
    e.nativeEvent.stopImmediatePropagation();
  };

  resendVerify = (e) => {
    e.preventDefault();
    this.setState({
      verificationCode: '',
      verificationCodeError: '',
    });
    const { token } = this.state;
    this.setState({
      errorText: '',
    });
    http(
      {
        url: 'selfservice/registration?_action=submitRequirements',
        data: {
          input: {
            resend: 'true',
          },
          token: token,
        },
        method: 'POST',
      },
      {
        'X-OpenIDM-NoSession': true,
        'X-OpenIDM-Username': 'anonymous',
        'X-OpenIDM-Password': 'anonymous',
      }
    ).then((res) => {
      if (res.status === 200 && res.data) {
        const token = getNestedObject(res, ['data', 'token']);
        if (token) {
          this.setState({
            token: token,
          });
        }
      } else if (
        res.status === 400 &&
        res.data &&
        res.data.code === 400 &&
        res.data.message === 'MAX_RESEND_EXCEEDED'
      ) {
        this.setState({
          screen: 0,
          currentStep: 0,
          password: '',
          confirmPassword: '',
          googleCaptchaResponse: '',
          captchaReset: false,
          givenName: '',

          answerOne: '',
          answerTwo: '',
          answerThree: '',
          sn: '',

          userName: '',
          businessName: '',
          businessRole: '',
          description: '',
          mail: '',
          confirmEmail: '',
          confirmPasswordError: '',
          businessNameError: '',
          businessRoleError: '',
          businessRoleDescriptionError: '',
          passwordError: '',
          formSubmitted: false,
          errorText: '',
          errorArray: [],
          token: '',
          telephoneNumber: '',
          telephoneNumberUSFormatted: '',
          verificationCode: '',
          verificationOption: '',
          verificationCodeError: '',
          questionVals: [null, null, null],
        });
        this.onErrorHandler('error', res.data.message);
        // this.getToken();
      }
    });
  };

  isFormFieldValid = (e, key) => {
    const value = e.target ? e.target.value.trim() : e;
    const { mail, confirmEmail, password, confirmPassword } = this.state;

    let errorMsg = '';
    switch (key) {
      case 'givenNameError':
        if (value.length <= 0) {
          errorMsg = 'errors.firstNameError';
        }
        break;
      case 'customeAppError':
        if (value.length <= 0) {
          errorMsg = 'errors.customeAppError';
        }
        break;
      case 'businessNameError':
        if (value.length <= 0) {
          errorMsg = 'errors.businessNameError';
        }
        break;
      case 'businessRoleError':
        if (value.length <= 0) {
          errorMsg = 'errors.businessRoleError';
        }
        break;
      /*
      case 'businessRoleDescriptionError':
        if (value.length <= 0) {
          errorMsg = 'errors.businessRoleDescriptionError';
        }
        break;
        */
      case 'answerOneError':
        if (value.length <= 0) {
          errorMsg = 'errors.answerOneError';
        }
        break;
      case 'answerTwoError':
        if (value.length <= 0) {
          errorMsg = 'errors.answerTwoError';
        }
        break;
      case 'answerThreeError':
        if (value.length <= 0) {
          errorMsg = 'errors.answerThreeError';
        }
        break;
      case 'snError':
        if (value.length <= 0) {
          errorMsg = 'errors.lastNameError';
        }
        break;
      case 'customApp2Error':
        if (value.length <= 0) {
          errorMsg = 'errors.customApp2Error';
        }
        break;
      case 'userNameError':
        if (value.length < 5 || value.length > 30) {
          errorMsg = 'errors.userNameLength';
        } else if (
          !value.match(/([a-zA-Z])*/) &&
          value.length >= 5 &&
          value.length <= 30
        ) {
          errorMsg = 'errors.userNameAtleastAlphabet';
        }
        break;
      case 'emailError':
        if (
          value.length <= 0 ||
          !value.match(
            /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/
          )
        ) {
          errorMsg = 'errors.emailError';
        }
        break;
      case 'confirmEmailError':
        if (value.length <= 0) {
          errorMsg = 'errors.confirmEmailError';
        } else if (mail !== confirmEmail) {
          errorMsg = 'errors.mailsNotMatchError';
        }
        break;
      case 'passwordError':
        if (value.length <= 0) {
          errorMsg = 'errors.noPasswordError';
        } else if (isPasswordFormatValid(value)) {
          errorMsg = 'errors.invalidFormat';
        }
        break;
      case 'confirmPasswordError':
        if (value.length <= 0) {
          errorMsg = 'errors.noConfirmPasswordError';
        } else if (password !== confirmPassword) {
          errorMsg = 'errors.passwordsError';
        }
        break;
      case 'telephoneNumberError':
        if (value.length <= 0) {
          errorMsg = 'errors.telephoneNumberEmpty';
        } else if (value.length !== 14) {
          errorMsg = 'errors.telephoneNumberError';
        }
        break;
      default:
        errorMsg = '';
        break;
    }
    this.setState({
      [key]: errorMsg,
    });
    return errorMsg;
  };

  decreaseCurrentStepHandler = () => {
    if (this.state.currentStep > 0) {
      this.setState((prev) => ({
        currentStep: prev.currentStep - 1,
        screen: prev.currentStep - 1,
      }));
    } else {
      this.sendToLogin();
    }
  };

  sendToLogin = (e) => {
    e.preventDefault();
    return this.props.history.push('/');
  };

  onCaptchaChange = (value) => {
    if (value) {
      this.setState(
        {
          googleCaptchaResponse: value,
        },
        () => {
          this.captchaSubmit();
        }
      );
    } else {
      this.setState({
        googleCaptchaResponse: '',
      });
    }
  };

  onFirstAndLastNameChange = (e, key) => {
    const {
      target: { value },
    } = e;
    if (value.match(/^[a-zA-Z '`,.-]*$/)) {
      this.setState({
        [key]: value,
      });
    }
  };

  onBusinessNameChange = (e, key) => {
    this.setState({
      [key]: e.value,
      businessNameError: '',
    });
  };

  getAvailableBusiness = () => {
    const availableOptionsLeft = this.state.organizationList;
    return availableOptionsLeft.filter((questionOption) => {
      return this.state.organizationList.indexOf(questionOption) === -1;
    });
  };
  onUserNameChange = (e, key) => {
    const value = e.target.value.trim();
    if (!value.match(/[\\+/""&'*%;, ]/g)) {
      this.setState({
        [key]: value,
      });
    }
  };

  showError = (errorText) => {
    this.setState({
      errorText,
    });
    this.scrollToTop();
  };

  handleQuestionValChange = (option, index) => {
    const newQuestionVals = this.state.questionVals;
    newQuestionVals[index] = option;
    this.setState(() => {
      return {
        questionVals: newQuestionVals,
      };
    });
  };

  getAvailableOptions = () => {
    const availableOptionsLeft = this.state.filterOptions;
    return availableOptionsLeft.filter((questionOption) => {
      return this.state.questionVals.indexOf(questionOption) === -1;
    });
  };

  onMobileNumberChange = (e) => {
    const currentValue = e.target.value.trim();
    this.setState((prevState) => ({
      ...prevState,
      telephoneNumber: formatPhoneNumber(currentValue, prevState.phoneNumber),
    }));
  };

  handleKeyPress = (e) => {
    preventNonDigitCharacters(e);
  };

  onBackLogin = (e) => {
    e.preventDefault();
    this.setState({
      screen: 0,
      currentStep: 0,
      password: '',
      confirmPassword: '',
      googleCaptchaResponse: '',
      captchaReset: false,
      givenName: '',
      customeApp: '',
      answerOne: '',
      answerTwo: '',
      answerThree: '',
      sn: '',

      userName: '',
      businessName: '',
      businessRole: '',
      businessRoleDescription: '',
      mail: '',
      confirmEmail: '',
      confirmPasswordError: '',
      businessNameError: '',
      businessRoleError: '',
      businessRoleDescriptionError: '',
      passwordError: '',
      formSubmitted: false,
      errorText: '',
      errorArray: [],
      token: '',
      telephoneNumber: '',
      telephoneNumberUSFormatted: '',
      verificationCode: '',
      verificationOption: '',
      verificationCodeError: '',
      questionVals: [null, null, null],
      copyEmailToUsername: false,
    });
    // this.getToken();
  };

  handleChange(evt) {
    const verificationCode = evt.target.validity.valid
      ? evt.target.value
      : this.state.verificationCode;
    this.setState({ verificationCode });
  }

  validateBusinessName = () => {
    let { businessName } = this.state;

    if (businessName.length <= 0) {
      this.setState({
        businessNameError: 'errors.businessNameError',
      });
    }
  };
  copyEmailToUsername(e) {
    this.setState(
      (prevState) => {
        return {
          copyEmailToUsername: !prevState.copyEmailToUsername,
        };
      },
      () => {
        let { copyEmailToUsername, mail } = this.state;
        let username = copyEmailToUsername ? mail : '';

        this.setState({
          userName: username,
          userNameError: '',
        });
      }
    );
  }

  render() {
    const {
      currentStep,
      maxStep,
      stepNames,
      screen,
      givenName,
      givenNameError,
      customeApp,
      customeAppError,
      sn,
      snError,
      customApp2,
      customApp2Error,
      userName,
      userNameError,
      businessName,
      businessRole,
      businessRoleDescription,
      mail,
      emailError,
      confirmEmail,
      confirmEmailError,
      password,
      passwordError,
      confirmPassword,
      confirmPasswordError,
      businessNameError,
      businessRoleError,
      businessRoleDescriptionError,
      formSubmitted,
      errorText,
      answerOne,
      answerTwo,
      answerThree,
      answerOneError,
      answerTwoError,
      answerThreeError,
      telephoneNumber,
      telephoneNumberError,
      numberFocus,
      verificationOption,
      verificationCodeError,
      errorArray,
      verificationCode,
      alertText,
      alertStatus,
      showGoogleCaptcha,
      googleCaptchaToken,
      captchaReset,
      copyEmailToUsername,
    } = this.state;
    const { t } = this.props;
    return (
      <>
        {alertText && (
          <Alert
            alertText={alertText}
            className={alertStatus}
            onAlertClose={() => {
              this.setState({
                alertText: '',
              });
            }}
          />
        )}
        <div className="registration registration-form">
          {(errorText || errorArray.length > 0) && (
            <WithError errors={errorText} errorArray={errorArray} />
          )}
          <div className="col">
            <h1>{t('pages.registration.businessRegisteration')}</h1>
          </div>
          <FormNavigationBar
            currentStep={currentStep}
            numFormSteps={maxStep + 1}
            stepNames={stepNames}
            t={t}
          />
          {currentStep === 0 && screen === 0 && (
            <div className="col-md-12 registration__container">
              <p>
                <span className="pr-2 red bold">*</span>
                {t('pages.registration.requiredFields')}
              </p>
              <Form>
                <Row>
                  <Col className="pr-2" lg={{ span: 6 }}>
                    <Form.Group controlId="firstName">
                      <Form.Label>
                        {t('pages.registration.firstName')}
                        <span className="red"> *</span>
                      </Form.Label>
                      <Form.Control
                        onChange={(e) => {
                          this.onFirstAndLastNameChange(e, 'givenName');
                        }}
                        value={givenName}
                        maxLength="40"
                        onBlur={(e) => {
                          this.isFormFieldValid(e, 'givenNameError');
                        }}
                        className={givenNameError ? 'error-input' : undefined}
                        aria-required
                        aria-invalid={!!givenNameError}
                        aria-describedby="firstname-error"
                      />
                      <p className="error-text" id="firstname-error">
                        {givenNameError && t(givenNameError)}
                      </p>
                    </Form.Group>
                  </Col>
                  <Col className="pl-2" lg={{ span: 6 }}>
                    <Form.Group controlId="lastName">
                      <Form.Label>
                        {t('pages.registration.lastName')}
                        <span className="red"> *</span>
                      </Form.Label>
                      <Form.Control
                        onChange={(e) => {
                          this.onFirstAndLastNameChange(e, 'sn');
                        }}
                        value={sn}
                        maxLength="80"
                        onBlur={(e) => {
                          this.isFormFieldValid(e, 'snError');
                        }}
                        className={snError ? 'error-input' : undefined}
                        aria-required
                        aria-invalid={!!snError}
                        aria-describedby="lastname-error"
                      />
                      <p className="error-text" id="lastname-error">
                        {snError && t(snError)}
                      </p>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col className="pr-2" lg={{ span: 6 }}>
                    <Form.Group controlId="email">
                      <Form.Label>
                        {t('pages.registration.email')}
                        <span className="red"> *</span>
                      </Form.Label>
                      <Form.Control
                        type="email"
                        onChange={(e) => {
                          this.setState({
                            mail: e.target.value.trim().toLowerCase(),
                          });
                        }}
                        onBlur={(e) => {
                          this.isFormFieldValid(e, 'emailError');
                        }}
                        value={mail}
                        aria-required
                        className={emailError ? 'error-input' : undefined}
                        aria-invalid={!!emailError}
                        aria-describedby="email-error"
                      />
                      <p>{t('pages.registration.emailContext')}</p>
                      <p className="error-text" id="email-error">
                        {emailError && t(emailError)}
                      </p>
                    </Form.Group>
                  </Col>
                  <Col className="pr-2" lg={{ span: 6 }}>
                    <Form.Group controlId="confirmEmail">
                      <Form.Label>
                        {t('pages.registration.confirmEmail')}
                        <span className="red"> *</span>
                      </Form.Label>
                      <Form.Control
                        type="email"
                        onChange={(e) => {
                          const value = e.target.value.trim().toLowerCase();
                          this.setState(
                            {
                              confirmEmail: value,
                            },
                            () => {
                              this.isFormFieldValid(value, 'confirmEmailError');
                            }
                          );
                        }}
                        onBlur={(e) => {
                          this.isFormFieldValid(e, 'confirmEmailError');
                        }}
                        value={confirmEmail}
                        className={
                          confirmEmailError ? 'error-input' : undefined
                        }
                        aria-required
                        aria-invalid={!!confirmEmailError}
                        aria-describedby="confirm-email-error"
                      />
                      <p className="error-text" id="confirm-email-error">
                        {confirmEmailError && t(confirmEmailError)}
                      </p>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col className="pr-2" lg={{ span: 6 }}>
                    <Form.Group controlId="userName">
                      <Form.Label>
                        {t('pages.registration.userName')}
                        <span className="red"> *</span>
                        <span style={{ 'margin-left': '2rem' }}>
                          <input
                            type="checkbox"
                            id="username"
                            name="username"
                            onChange={(e) => {
                              this.copyEmailToUsername(e);
                            }}
                          ></input>
                          <label
                            style={{
                              'font-weight': '400',
                              margin: 'auto',
                              'margin-left': '0.5rem',
                            }}
                          >
                            {t('pages.registration.copyEmail')}
                          </label>
                        </span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        onChange={(e) => {
                          this.onUserNameChange(e, 'userName');
                        }}
                        value={userName}
                        maxLength="30"
                        onBlur={(e) => {
                          this.isFormFieldValid(e, 'userNameError');
                        }}
                        className={userNameError ? 'error-input' : undefined}
                        aria-required
                        autoComplete="off"
                        aria-invalid={!!userNameError}
                        aria-describedby="username-error"
                        disabled={copyEmailToUsername}
                      />
                      <p className="error-text" id="username-error">
                        {userNameError && t(userNameError)}
                      </p>
                    </Form.Group>
                  </Col>
                  <Col className="pr-2" lg={{ span: 6 }}>
                    <Form.Group controlId="telephoneNumber">
                      <Form.Label>
                        {t('pages.registration.telephoneNumber')}
                        <span className="red"> *</span>
                      </Form.Label>
                      <Form.Control
                        ref={this.telephoneNumberInputRef}
                        onKeyDown={this.handleKeyPress}
                        placeholder={!numberFocus ? '(###) ###-####' : ''}
                        onFocus={() => {
                          this.setState({
                            numberFocus: true,
                          });
                        }}
                        onBlur={(e) => {
                          this.isFormFieldValid(e, 'telephoneNumberError');
                        }}
                        onChange={this.onMobileNumberChange}
                        value={telephoneNumber}
                        aria-required
                        className={
                          telephoneNumberError ? 'error-input' : undefined
                        }
                        aria-invalid={!!telephoneNumberError}
                        aria-describedby="mobile-number-error"
                      />
                      <p className="error-text" id="mobile-number-error">
                        {telephoneNumberError && t(telephoneNumberError)}
                      </p>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col className="pr-2" lg={{ span: 6 }}>
                    <Form.Group controlId="businessName">
                      <Form.Label>
                        {t('pages.registration.businessName')}
                        <span className="red"> *</span>
                      </Form.Label>
                      <Select
                        name="filters"
                        placeholder={t('pages.registration.businessName')}
                        options={this.state.organizationList}
                        onChange={(e) => {
                          this.onBusinessNameChange(e, 'businessName');
                        }}
                        onBlur={(e) => {
                          this.validateBusinessName();
                        }}
                        className={businessNameError ? 'error-input' : ''}
                        aria-required
                        aria-invalid={!!businessNameError}
                        aria-describedby="firstname-error"
                        aria-label="list"
                      />

                      <p className="error-text" id="firstname-error">
                        {businessNameError && t(businessNameError)}
                      </p>
                    </Form.Group>
                  </Col>
                  <Col className="pl-2" lg={{ span: 6 }}>
                    <Form.Group controlId="businessRole">
                      <Form.Label>
                        {t('pages.registration.businessRole')}
                        <span className="red"> *</span>
                      </Form.Label>
                      <Form.Control
                        onChange={(e) => {
                          this.onUserNameChange(e, 'businessRole');
                        }}
                        value={businessRole}
                        maxLength="80"
                        onBlur={(e) => {
                          this.isFormFieldValid(e, 'businessRoleError');
                        }}
                        className={
                          businessRoleError ? 'error-input' : undefined
                        }
                        aria-required
                        aria-invalid={!!businessRoleError}
                        aria-describedby="lastname-error"
                      />
                      <p className="error-text" id="lastname-error">
                        {businessRoleError && t(businessRoleError)}
                      </p>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col className="pr-2" lg={{ span: 6 }}>
                    <Form.Group controlId="passWord">
                      <Form.Label>
                        {t('pages.registration.password')}
                        <span className="red"> *</span>
                      </Form.Label>
                      <PasswordField
                        onChange={(value) => {
                          this.setState({
                            password: value,
                          });
                        }}
                        onBlur={(e) => {
                          this.isFormFieldValid(e, 'passwordError');
                        }}
                        password={password}
                        className={passwordError ? 'error-input' : undefined}
                        aria-required
                        ariaInvalid={!!passwordError}
                        ariaDescribedby="password-error"
                        myRef={this.passwordInputRef}
                        onCopy={(e) => {
                          this.disableCopyPaste(e);
                        }}
                        onPaste={(e) => {
                          this.disableCopyPaste(e);
                        }}
                      />
                    </Form.Group>
                    <p className="error-text" id="password-error">
                      {passwordError && t(passwordError)}
                    </p>
                  </Col>
                  <Col className="pr-2" lg={{ span: 6 }}>
                    <Form.Group controlId="confirmPassWord">
                      <Form.Label>
                        {t('pages.registration.confirmPassword')}
                        <span className="red"> *</span>
                      </Form.Label>
                      <PasswordField
                        onChange={(value) => {
                          this.setState(
                            {
                              confirmPassword: value,
                            },
                            () => {
                              this.isFormFieldValid(
                                value,
                                'confirmPasswordError'
                              );
                            }
                          );
                        }}
                        onBlur={(e) => {
                          this.isFormFieldValid(e, 'confirmPasswordError');
                        }}
                        password={confirmPassword}
                        className={
                          confirmPasswordError ? 'error-input' : undefined
                        }
                        aria-required
                        ariaInvalid={!!confirmPasswordError}
                        ariaDescribedby="confirm-password-error"
                        myRef={this.confirmPasswordInputRef}
                        onCopy={(e) => {
                          this.disableCopyPaste(e);
                        }}
                        onPaste={(e) => {
                          this.disableCopyPaste(e);
                        }}
                      />
                    </Form.Group>
                    <p className="error-text" id="confirm-password-error">
                      {confirmPasswordError && t(confirmPasswordError)}
                    </p>
                  </Col>
                </Row>
                <Form.Group controlId="businessRoleDescription">
                  <Form.Label>
                    {t('pages.registration.businessRoleDescription')}
                  </Form.Label>
                  <Form.Control
                    onChange={(e) => {
                      this.onUserNameChange(e, 'businessRoleDescription');
                    }}
                    value={businessRoleDescription}
                    as="textarea"
                    maxLength="40"
                    onBlur={(e) => {
                      this.isFormFieldValid(e, 'businessRoleDescriptionError');
                    }}
                    className={
                      businessRoleDescriptionError ? 'error-input' : undefined
                    }
                    aria-required
                    aria-invalid={!!businessRoleDescriptionError}
                    aria-describedby="firstname-error"
                  />
                  {/*
                  <p className="error-text" id="firstname-error">
                    {businessRoleDescriptionError &&
                      t(businessRoleDescriptionError)}
                    </p>*/}
                </Form.Group>
                {/* <Form.Row>
                  <Col className="pr-2" lg={{ span: 6 }}>
                    <Form.Group controlId="customeApp">
                      <Form.Label>
                        {t('pages.registration.customeApp')}
                        <span className="red"> *</span>
                      </Form.Label>
                      <Form.Control
                        onChange={(e) => {
                          this.onCustomAppChange(e, 'customeApp');
                        }}
                        value={customeApp}
                        maxLength="40"
                        onBlur={(e) => {
                          this.isFormFieldValid(e, 'customeAppError');
                        }}
                        className={customeAppError ? 'error-input' : undefined}
                        aria-required
                        aria-invalid={!!customeAppError}
                        aria-describedby="firstname-error"
                      />
                      <p className="error-text" id="firstname-error">
                        {customeAppError && t(customeAppError)}
                      </p>
                    </Form.Group>
                  </Col>
                  <Col className="pl-2" lg={{ span: 6 }}>
                    <Form.Group controlId="customApp2">
                      <Form.Label>
                        {t('pages.registration.customApp2')}
                        <span className="red"> *</span>
                      </Form.Label>
                      <Form.Control
                        onChange={(e) => {
                          this.onFirstAndLastNameChange(e, 'customApp2');
                        }}
                        value={customApp2}
                        maxLength="80"
                        onBlur={(e) => {
                          this.isFormFieldValid(e, 'customApp2');
                        }}
                        className={customApp2Error ? 'error-input' : undefined}
                        aria-required
                        aria-invalid={!!customApp2Error}
                        aria-describedby="lastname-error"
                      />
                      <p className="error-text" id="lastname-error">
                        {customApp2Error && t(customApp2Error)}
                      </p>
                    </Form.Group>
                  </Col>
                </Form.Row> */}
                <div className="mt-3">
                  <PasswordRequirements
                    password={password}
                    formSubmitted={formSubmitted}
                  />
                </div>
                <div className="row pt-3">
                  <div className="d-sm-flex col-lg-6 col-md-12">
                    <Button
                      className="col btn btn-secondary hollow mr-sm-4 py-2 my-3"
                      onClick={(e) => this.sendToLogin(e)}
                      variant="primary"
                      block
                    >
                      {t('pages.forgotPassword.backBtn')}
                    </Button>
                    <Button
                      className="col btn btn-secondary py-2 my-3"
                      type="submit"
                      onClick={(e) => this.onSubmit(e)}
                    >
                      {t('pages.registration.registration')}
                    </Button>
                  </div>
                </div>
              </Form>
              <div className="separator-light mt-4 mb-4"></div>
            </div>
          )}
          {currentStep === 1 && screen === 1 && (
            <div className="col-md-12 registration__container">
              <h3>
                <span>{t('pages.registration.signUpSecurityQuestion')}</span>
              </h3>
              <p>
                <span className="pr-2 red bold">*</span>
                {t('pages.registration.requiredFields')}
              </p>
              <div>
                <Form>
                  <label>
                    {t('pages.registration.question1')}
                    <span className="red"> *</span>
                  </label>
                  <Select
                    name="filters"
                    placeholder="Question 1"
                    value={this.state.questionVals[0]}
                    options={this.getAvailableOptions()}
                    onChange={(e) => {
                      this.handleQuestionValChange(e, 0);
                    }}
                    className={`select-box`}
                  />
                  <Form.Group controlId="answerOne">
                    <Form.Control
                      onChange={(e) => {
                        this.onFirstAndLastNameChange(e, 'answerOne');
                      }}
                      value={answerOne}
                      maxLength="40"
                      onBlur={(e) => {
                        this.isFormFieldValid(e, 'answerOneError');
                      }}
                      className={`answer-input ${
                        answerOneError ? 'error-input' : undefined
                      }`}
                      aria-required
                      aria-invalid={!!answerOneError}
                      aria-describedby="firstname-error"
                    />
                  </Form.Group>
                  <label>
                    {t('pages.registration.question2')}
                    <span className="red"> *</span>
                  </label>
                  <Select
                    name="filters"
                    placeholder="Question 2"
                    value={this.state.questionVals[1]}
                    options={this.getAvailableOptions()}
                    onChange={(e) => {
                      this.handleQuestionValChange(e, 1);
                    }}
                    className={`select-box`}
                  />
                  <Form.Group controlId="answerTwo">
                    <Form.Control
                      onChange={(e) => {
                        this.onFirstAndLastNameChange(e, 'answerTwo');
                      }}
                      value={answerTwo}
                      maxLength="40"
                      onBlur={(e) => {
                        this.isFormFieldValid(e, 'answerTwoError');
                      }}
                      className={`answer-input ${
                        answerTwoError ? 'error-input' : undefined
                      }`}
                      aria-required
                      aria-invalid={!!answerTwoError}
                      aria-describedby="firstname-error"
                    />
                  </Form.Group>
                  <label>
                    {t('pages.registration.question3')}
                    <span className="red"> *</span>
                  </label>
                  <Select
                    name="filters"
                    placeholder="Question 3"
                    value={this.state.questionVals[2]}
                    options={this.getAvailableOptions()}
                    onChange={(e) => {
                      this.handleQuestionValChange(e, 2);
                    }}
                    className={`select-box`}
                  />
                  <Form.Group controlId="answerThree">
                    <Form.Control
                      onChange={(e) => {
                        this.onFirstAndLastNameChange(e, 'answerThree');
                      }}
                      value={answerThree}
                      maxLength="40"
                      onBlur={(e) => {
                        this.isFormFieldValid(e, 'answerThreeError');
                      }}
                      className={`answer-input ${
                        answerThreeError ? 'error-input' : undefined
                      }`}
                      aria-required
                      aria-invalid={!!answerThreeError}
                      aria-describedby="firstname-error"
                    />
                  </Form.Group>
                  <div className="row pt-3">
                    <div className="d-sm-flex col-lg-6 col-md-12">
                      <Button
                        className="col btn btn-secondary hollow  mr-sm-4 py-2 my-3"
                        onClick={(e) => this.onBackLogin(e)}
                        variant="primary"
                        block
                      >
                        {t('pages.registration.back')}
                      </Button>
                      <Button
                        className="col btn btn-secondary  py-2 my-3"
                        onClick={(e) => this.onVerify(e)}
                      >
                        {t('pages.registration.verify')}
                      </Button>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          )}
          {currentStep === 2 && screen === 4 && (
            <>
              <div className="captcha">
                <div className="col">
                  <h2 className="mb-4">{t('pages.forgotPassword.header3')}</h2>
                </div>
                <div className="col-md-6 mt-3 mb-9">
                  <div className="google-captcha">
                    <div className="google-captcha__box">
                      <GoogleCaptcha
                        sitekey="6LfZ2x4bAAAAAHSjeTiNi9PNJl_THRGSbg_bJUvd"
                        onCaptchaChange={this.onCaptchaChange}
                        captchaReset={captchaReset}
                      />
                    </div>
                  </div>
                </div>
                <div className="d-flex col-md-3">
                  <Button
                    className="col btn btn-secondary hollow mr-sm-4 py-2 my-3"
                    type="submit"
                    onClick={(e) => this.decreaseCurrentStepHandler(e)}
                  >
                    {t('pages.forgotUserId.backBtn')}
                  </Button>
                </div>
              </div>
            </>
          )}
          {currentStep === 3 && screen === 2 && verificationOption && (
            <div className="col-md-12 registration__container">
              <div className="registration__container__resend-verification">
                <div className="registration__container__resend-verification__resend-text">
                  <h3>
                    {t('pages.registration.verificationCodeSentTo')}{' '}
                    {verificationOption}
                  </h3>
                </div>
              </div>
              <Form>
                <Form.Group
                  className="verification-form"
                  controlId="verificationCode"
                >
                  <Form.Label className="mb-4">
                    {t('pages.registration.verificationCode')}
                  </Form.Label>
                  <input
                    type="text"
                    pattern="[0-9]*"
                    onInput={this.handleChange.bind(this)}
                    className="ml-3"
                    value={verificationCode}
                  />
                  {verificationCodeError && (
                    <p className="error-text" id="verification-error">
                      {verificationCodeError && t(verificationCodeError)}
                    </p>
                  )}
                </Form.Group>
                <div className="registration__container__resend-verification__resend-text">
                  <p
                    className="resend-link"
                    onClick={(e) => this.resendVerify(e)}
                    role="button"
                    tabIndex={0}
                  >
                    {t('pages.registration.resendVerificationCode')}
                  </p>
                </div>
                <div className="registration__container__pleasenote">
                  <p className="registration__container__pleasenote-fp">
                    {t('pages.registration.note')}
                  </p>
                  <p className="registration__container__pleasenote-sp">
                    {t('pages.registration.verifyNote')}
                  </p>
                </div>

                <div className="row pt-3">
                  <div className="d-sm-flex col-lg-6 col-md-12">
                    <Button
                      className="col btn btn-secondary hollow mr-sm-4  py-2 my-3"
                      onClick={(e) => this.onBackLogin(e)}
                      variant="primary"
                      block
                    >
                      {t('pages.forgotPassword.backBtn')}
                    </Button>
                    <Button
                      className="col btn btn-secondary py-2 my-3"
                      onClick={(e) => this.onVerificationCodeSubmit(e)}
                      type="submit"
                    >
                      {t('pages.registration.verify')}
                    </Button>
                  </div>
                </div>
              </Form>
            </div>
          )}
          {currentStep === 3 && screen === 3 && (
            <div className="col-md-12 registration__container mb-5">
              <>
                <Pending
                  emailVerify={t(
                    'pages.registration.welcomeBusinessRegistration'
                  )}
                />
                <div className="row pt-3">
                  <div className="d-sm-flex col-lg-3 col-md-12">
                    <Button
                      className="col btn btn-secondary py-2 my-3"
                      onClick={this.sendToLogin}
                      type="submit"
                    >
                      {t('pages.forgotPassword.loginBtn')}
                    </Button>
                  </div>
                </div>
              </>
            </div>
          )}
        </div>
      </>
    );
  }
}
BusinessRegistration.propTypes = {
  t: PropTypes.func.isRequired,
  history: PropTypes.object,
};
export default withTranslation()(BusinessRegistration);
